<ziro-self-serve-top-bar></ziro-self-serve-top-bar>

<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

@if (!isLoading) {
  <div data-automation="replace-deskphone-component">
    @if (canReplaceDeskphone && !buildFailed) {
      <div>
        <div class="row col-12 overflow-hidden">
          <div
            [attr.data-automation]="'phone-buttons-template'"
            class="position-relative phone-buttons-container"
            [ngClass]="{
              'custom-col-lg-6': currentStep === 1 && animationCurrentStep === 1,
              'col-lg-6': !(currentStep === 1 && animationCurrentStep === 1),
            }"
          >
            <!-- Display Phone buttons on step 1 -->
            @if (currentStep === 1 && animationCurrentStep === 1) {
              <div [@stepAnimation]="currentStep" [ngClass]="{ 'phone-buttons--loaded': !isLoading }">
                <ziro-phone-buttons [userMode]="userMode" [serverId]="cucmServerId.toString()"></ziro-phone-buttons>
              </div>
            }
            <!-- Display animations starting from step 2 -->
            @if (currentStep > 1) {
              <ziro-multi-step-animation
                [currentStep]="animationCurrentStep"
                [steps]="lottieAnimationSteps"
                [animationStart$]="animationReplaySource.asObservable()"
              ></ziro-multi-step-animation>
            }
          </div>
          <div
            class="phone-step-container d-flex align-items-center justify-content-center position-relative"
            [ngClass]="{
              'custom-col-lg-6': currentStep === 1 && animationCurrentStep === 1,
              'col-lg-6': !(currentStep === 1 && animationCurrentStep === 1),
            }"
          >
            @if (currentStep === 1) {
              <div
                [@stepAnimation]
                [ngClass]="{ 'phone-step-container__step--active': currentStep === 1 }"
                class="row w-100 phone-step-container__step"
                data-automation="replace-deskphone-step-1"
              >
                <div class="col-12 overflow-hidden">
                  <div class="row">
                    <div class="col-12 align-content-center d-flex flex-wrap">
                      <div>
                        <h2 class="w-100 text-start">
                          {{ 'tkey;selfserve.user.replace_deskphone.step_one.title' | translate }}
                        </h2>
                        <p
                          class="text-start d-inline-block"
                          [innerHTML]="
                            'tkey;selfserve.user.replace_deskphone.step_one.body'
                              | escapeHtml: { name: currentUserRef.firstName }
                          "
                        ></p>
                        <div class="text-end">
                          <ziro-button
                            [dataAutomation]="'replacee-deskphone-cancel-step-1-button'"
                            (click)="onCancelClick()"
                            [buttonSize]="buttonSizes.LARGE"
                            [buttonStyle]="buttonStyles.OUTLINE_DEFAULT"
                            [label]="'tkey;global.button.cancel.text'"
                            class="me-1"
                          ></ziro-button>
                          <ziro-button
                            [dataAutomation]="'replace-deskphone-begin-button'"
                            (click)="onBeginClick()"
                            [buttonSize]="buttonSizes.LARGE"
                            [buttonStyle]="buttonStyles.OUTLINE_PRIMARY"
                            [label]="'tkey;selfserve.user.replace_deskphone.step_one.button.title'"
                          ></ziro-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (currentStep === 2) {
              <div
                [@stepAnimation]="currentStep === 2"
                [ngClass]="{ 'phone-step-container__step--active': currentStep === 2 }"
                class="row phone-step-container__step"
                data-automation="replace-deskphone-step-2"
              >
                <div class="col-12">
                  <div class="row">
                    <div class="col-12 align-content-center d-flex flex-wrap">
                      <div>
                        <h2 class="w-100 text-start">
                          {{ 'tkey;selfserve.user.replace_deskphone.step_two.title' | translate }}
                        </h2>
                        <h5 class="w-100 text-start">
                          {{ 'tkey;selfserve.user.replace_deskphone.step_two.body' | translate }}
                        </h5>
                        <ul class="mt-3 w-100 text-start">
                          <li>
                            {{ 'tkey;selfserve.user.replace_deskphone.step_two.body.two' | translate }}
                          </li>
                          <li>
                            {{ 'tkey;selfserve.user.replace_deskphone.step_two.body.three' | translate }}
                          </li>
                        </ul>
                        <div class="text-end">
                          <ziro-button
                            [dataAutomation]="'replace-deskphone-cancel-step-2-button'"
                            (click)="onCancelClick()"
                            [buttonSize]="buttonSizes.LARGE"
                            [buttonStyle]="buttonStyles.OUTLINE_DEFAULT"
                            [label]="'tkey;global.button.cancel.text'"
                            class="me-1"
                          ></ziro-button>
                          <ziro-button
                            [dataAutomation]="'replace-deskphone-next-button'"
                            (click)="onNextClick()"
                            [buttonSize]="buttonSizes.LARGE"
                            [buttonStyle]="buttonStyles.OUTLINE_PRIMARY"
                            [label]="'tkey;global.button.next.text'"
                          ></ziro-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (currentStep === 4) {
              <div
                [@stepAnimation]="currentStep === 4"
                [ngClass]="{ 'phone-step-container__step--active': currentStep === 4 }"
                class="row phone-step-container__step"
                data-automation="replace-deskphone-step-4"
              >
                <div class="col-12 align-content-center d-flex flex-wrap overflow-hidden">
                  <h2 class="w-100 text-start">
                    {{ 'tkey;selfserve.user.activate_deskphone.step_four.body' | translate }}
                  </h2>
                  <h5 class="w-100 text-start">
                    {{ 'tkey;selfserve.user.activate_deskphone.step_four.body.two' | translate }}
                  </h5>
                  <p
                    class="w-100 text-start mt-3"
                    [innerHtml]="'tkey;selfserve.user.replace_deskphone.step_four.body.three' | escapeHtml"
                  ></p>
                </div>
              </div>
            }
            @if (currentStep === 5) {
              <div
                [@stepAnimation]="currentStep === 5"
                [ngClass]="{ 'phone-step-container__step--active': currentStep === 5 }"
                class="row phone-step-container__step"
                data-automation="replace-deskphone-step-5"
              >
                <div class="col-12">
                  <div class="row">
                    <div class="col-12 align-content-center d-flex flex-wrap">
                      <div>
                        <h2
                          class="w-100 text-start"
                          [innerHTML]="'tkey;selfserve.user.replace_deskphone.step_five.body' | escapeHtml"
                        ></h2>
                        <p class="w-100 text-start">
                          {{ 'tkey;selfserve.user.replace_deskphone.step_five.body.two' | translate }}
                        </p>
                        <div class="text-end">
                          <a
                            [routerLink]="['/self-serve/user/', username]"
                            class="btn btn-border btn-primary btn-lg"
                            data-automation="replace-deskphone-return-button"
                          >
                            {{ 'tkey;selfserve.user.replace_deskphone.return_button.title' | translate }}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            <div
              [hidden]="currentStep !== 3"
              [ngClass]="{ 'phone-step-container__step--active': currentStep === 3 }"
              class="row phone-step-container__step animate__fadeIn animate__animated animation-delay-half-second"
              data-automation="activate-phone-step-3"
            >
              <div class="col-12">
                <div class="row">
                  <div class="col-12 align-content-center d-flex flex-wrap">
                    <div>
                      <h2 class="w-100 text-start">
                        {{ 'tkey;selfserve.user.replace_deskphone.step_three.title' | translate }}
                      </h2>
                      <h5
                        class="w-100 text-start"
                        [innerHTML]="'tkey;selfserve.user.replace_deskphone.step_three.body' | escapeHtml"
                      ></h5>
                      <ziro-text fieldId="extension"></ziro-text>
                      <div class="text-end">
                        <ziro-button
                          [dataAutomation]="'replace-deskphone-cancel-step-3-button'"
                          (click)="onCancelClick()"
                          [buttonSize]="buttonSizes.LARGE"
                          [buttonStyle]="buttonStyles.OUTLINE_DEFAULT"
                          [label]="'tkey;global.button.cancel.text'"
                          class="me-1"
                        ></ziro-button>
                        <ziro-submit-button
                          [isPending]="isSubmitting || isPhoneRegistering"
                          [isDisabled]="isSubmitting || !isFormValid()"
                          [label]="'tkey;selfserve.user.replace_deskphone.save'"
                          [labelPending]="'tkey;selfserve.user.replace_deskphone.saving'"
                          [dataAutomation]="'replace-deskphone-button'"
                          [buttonStyle]="buttonStyles.OUTLINE_PRIMARY"
                          [iconPending]="ziroIcons.SAVING"
                          [formSubmitSubject]="_validateAndSubmitSource"
                          [buttonSize]="buttonSizes.LARGE"
                        ></ziro-submit-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    @if (!canReplaceDeskphone || buildFailed) {
      <div class="d-flex justify-content-center">
        <div class="text-center my-5" data-automation="misconfiguration-alert">
          <h2>
            @if (expansionModuleDetected) {
              <i class="{{ ziroIcons.CIRCLE_EXCLAMATION }} text-warning me-2"></i>
            }
            @if (buildFailed) {
              <i class="{{ ziroIcons.WARNING_TRIANGLE }} text-warning me-2"></i>
            }
            {{ getWarningTextTitle() }}
          </h2>
          <hr />
          <p [innerHTML]="getWarningTextDescription() | escapeHtml"></p>
          @if (expansionModuleDetected || buildFailed) {
            <ziro-button
              [dataAutomation]="'expansion-module-prompt-cancel-button'"
              (click)="onCancelClick()"
              [buttonSize]="buttonSizes.LARGE"
              [buttonStyle]="buttonStyles.OUTLINE_PRIMARY"
              [label]="'tkey;selfserve.user.replace_deskphone.return_button.title'"
              class="me-1"
            ></ziro-button>
          }
        </div>
      </div>
    }
  </div>
}
